import { Pipe, PipeTransform } from '@angular/core';
import { Utils } from 'src/app/utils.class';

@Pipe({
    name: 'makeKey',
    pure: true,
    standalone: false,
})
export class EmployeePlanningMakeKeyPipe implements PipeTransform {
    // Pure pipe bindings reuse this result until the date or one of the key parts changes.
    transform(date: Date | string, ...parts: Array<string | number | null | undefined>): string {
        let key = typeof date === 'string' ? date : Utils.formatDate(date);

        for (const part of parts) {
            if (part !== null && part !== undefined && part !== '') {
                key += `-${part}`;
            }
        }

        return key;
    }
}
